import { formatDateTime, parseISOToLocale } from '@vlabs/shared/utils/date';

export const getFormattedVaEventDateForCard = (createTime, endTime) => {
  const start = formatDateTime(createTime);
  const end = formatDateTime(endTime, 'HH:mm:ss');

  if (parseISOToLocale(createTime) === parseISOToLocale(endTime)) return start;

  return `${start} - ${end}`;
};

export const getFormattedVaEventDateForDetails = (createTime, endTime) => {
  const start = parseISOToLocale(createTime);
  const end = parseISOToLocale(endTime);
  if (start === end) return start;

  return `${start} - ${end}`;
};
